import React from 'react';

const PageHero = ({ title, highlight, subtitle }) => {
  return (
    <div className="bg-gradient-to-br from-gray-900 to-gray-800 flex items-center min-h-[42vh] pt-24 pb-12">
      <div className="max-w-screen-xl mx-auto px-6 text-center w-full">
        <h1 className="text-white text-4xl md:text-6xl font-extrabold">
          {title} <span className="text-red-500">{highlight}</span>
        </h1>
        {subtitle && (
          <p className="text-gray-300 mt-4 text-lg max-w-xl mx-auto">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default PageHero;
